import axios from "../utils/axios";

export const getAreaList = () => {
    return axios.get(`/Area/GetList`);
};

export const getMaintenanceType = () => {
    return axios.get(`MaintenanceType/GetList`);
};

export const getPMGetOrderDetailById = (payload) => {
    return axios.get(`/PlannedMaintenance/GetOrderDetailById?id=${payload}`);
};

export const postPMCreateOrder = (payload) => {
    return axios.post(`/PlannedMaintenance/CreateOrder`, payload);
};

export const postPMUpdateOrder = (payload) => {
    return axios.post(`/PlannedMaintenance/UpdateOrder`, payload);
};

export const getPMGetOrderFiles = (payload) => {
    return axios.get(`/PlannedMaintenance/GetOrderFiles?orderId=${payload}`);
};

export const postPMAddFile = (payload) => {
    return axios.post(`/PlannedMaintenance/AddFile`, payload);
};

export const getPMOrderList = () => {
    return axios.get(`/PlannedMaintenance/GetOrderList`);
};

export const getPMOrderListPage = (payload) => {
    return axios.post(`/PlannedMaintenance/GetOrdersPage?PageSize=${payload.pageSize}&PageNumber=${payload.pageNumber}`, payload.body);
};

export const deletePMOrder = (payload) => {
    return axios.post(`/PlannedMaintenance/DeleteOrder?plannedMaintenanceOrderId=${payload}`);
};

export const getPlannedCheckItemGroupsById = (payload) => {
    return axios.get(`/PlannedMaintenance/orders/${payload}/CheckItemGroups`);
};

export const getPlannedCheckItemsForTask = (payload) => {
    return axios.get(`/PlannedMaintenance/tasks/${payload}/CheckItems`);
};

export const putPlannedCheckItemsForTask = (payload) => {
    return axios.put(`/PlannedMaintenance/tasks/${payload.taskId}/CheckItems`, payload.data);
};
